<template>
    <div id="main">
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>
        <div class="page acerto">
            <div class="vertical-flow">
                <div class="columns listing-header is-desktop">
                    <div class="column">
                        <!-- TÍTULO E BREADCRUMB -->
                        <h1 class="title">
                            {{ $t("acerto") }}
                            {{ !idacerto ? "" : ": " + idacerto }}
                            {{ $route.query.userName ? " - " + $route.query.userName : '' }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li><a class="a-inativo">{{ $t("despesas") }}</a></li>
                                <li><a @click="$router.push({ name : 'des-acertos' })">{{ $t("acertos") }}</a></li>
                                <li v-if="!idacerto"><a aria-current="page">{{ $t("novo-acerto") }}</a></li>
                            </ul>
                        </nav>
                    </div>
                    <!-- BOTÕES DE AÇÃO -->
                    <div class="form-buttons">
                        <button class="delete-btn" type="button" tag="button" @click="$router.push({ name : 'des-acertos' })">
                            {{ $t('voltar') }}
                        </button>
                        <button
                            @click="onClickPrint()"
                            :class="!idacerto ? 'delete-btn' : 'save-btn'"
                            v-if="$route.params.situacaoId && idacerto && permissao.export"
                        >
                            {{ $t("imprimir") }}
                        </button>
                        <button  
                            @click="onClickFinish()" 
                            class="save-btn" 
                            v-if="!idacerto && permissao.create"
                        >
                            {{ $t("finalizar") }}
                        </button>
                    </div>
                </div>
                <div v-if="!idacerto" class="columns">
                    <div class="column">
                    <label><span>{{ $t('selecionar-da-empresa') }}</span></label>
                        <vss-select
                            v-model="empresasInner"
                            label="nome"
                            :options="empresas"
                            @input="selecionaEmpresa()"
                            no-clearfix multiple clearable
                        >
                            <template #multiple-selected="{ selected }">
                                ({{ selected && selected.length > 0 ? nomesEmpresas : $t('todos') }})
                            </template>
                        </vss-select>
                    </div>
                </div>

                <!-- TABS -->
                <ul class="nav nav-tabs mb-2">
                    <li 
                        v-for="(tab, i) in tabs"
                        :key="i"
                        :class="{ active: tabSelecionada == tabs[i] }"
                        @click="updateTabs(tabs[i])"
                    >
                        <a data-toggle="tab">{{ tab | truncate(16) }}</a>
                    </li>
                </ul>
                <!-- CONJTO DE ABAS - MOBILE -->
                <b-dropdown aria-role="list" class="mobile-tab-list">
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            {{ tabSelecionada }}
                        </span>
                        <i class="mdi mdi-chevron-down"></i>
                    </div>

                    <b-dropdown-item
                        v-for="(tab, i) in tabs"
                        :key="i"
                        @click="tabSelecionada = tabs[i]"
                        class="mobile-tab-list-item"
                        aria-role="listitem"
                        :class="{ active: tabSelecionada == tabs[i] }"
                    >
                        {{ tab }}
                    </b-dropdown-item>
                </b-dropdown>

                <section class="lps-table registry-wrapper">
                    <empty-table-message msg="msg-acerto-deletado" class="mt-3" v-if="!$route.params.situacaoId" />
                    <ContainerLoader v-if="isGeneratingExpenses" />
                    <Adiantamento
                        v-show="showThisTab(tabSelecionada, 'adiantamentos')"
                        :adiantamentos="adiantamentos"
                        :empresasInner="empresasInner"
                        :valorTotalAdiantamentos="valorTotalAdiantamentos"
                        :idacerto="acerto.idacerto"
                        @adiantamentos-selecionados="recebeAdiantamentosSelecionados($event)"
                    />
                    <div v-for="(motivoDespesa, i) in motivosDespesas" :key="i">
                        <keep-alive>
                            <Despesas
                                v-if="showThisTab(tabSelecionada, motivoDespesa.descricao)"
                                :motivodespesa="motivoDespesa"
                                :despesas="motivoDespesa.despesas"
                                :propDespesasSelecionadas="despesasSelecionadas"
                                @despesas-selecionadas="recebeDespesasSelecionadas($event)"
                            />
                        </keep-alive>
                    </div>
                </section>
                <!--Footer-->
                <keep-alive>
                    <div class="acerto-footer">
                        <hr class="margin-none" />
                        <div class="columns margin-none">
                            <div class="column has-text-centered adiantamento-footer">
                                <div div class="th-wrap">
                                    <strong>
                                        {{ $t("adiantamentos") }}
                                        {{ valorTotalAdiantamentos | decimal(null, true) }}
                                    </strong>
                                </div>
                            </div>
                            <div class="column has-text-centered">
                                <div class="th-wrap">
                                    <strong>
                                        {{ $t("gastos") }}
                                        {{ valorTotalDespesas | decimal(null, true) }}
                                    </strong>
                                </div>
                            </div>
                            <div class="column has-text-centered">
                                <div class="th-wrap">
                                    <strong>
                                        {{ $t("total-acerto") }}
                                        {{  
                                            calcularTotalAcerto() | decimal(null, true)
                                        }}
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </keep-alive>
            </div>
            <!-- Modal Imprimir acerto -->
            <b-modal
                class="modal-default"
                :active.sync="isShowModalPrint"
                style="z-index: 1000"
                @close="onClickPrint()"
            >
                <ContainerLoader v-if="isLoadingPrint" />
                <div class="modal-card-body">
                    <div class="listing-header">
                        <div class="title-breadcrumb">
                            <h1 class="title">
                                {{ $t("selecione-recibo") }}
                            </h1>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div>
                            <label>{{ $t("recibos") }}</label>
                            <s-select
                                v-if="!isLoadingPrint"
                                class="select-recibo"
                                v-model="confReciboJasper"
                                :options="modelosRecibos"
                                label="titulo"
                            />
                        </div>
                    </div>
                    <div class="form-buttons mb-4">
                        <button class="delete-btn" @click="onClickPrint()">
                            {{ $t("voltar") }}
                        </button>
                        <button @click="exportarAcerto()" class="save-btn">
                            {{ $t("imprimir") }}
                        </button>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
//Services
import AdiantamentoService from "@/services/despesas/AdiantamentoService";
import AcertoService from "@/services/despesas/AcertosService";
import DespesaService from "@/services/despesas/DespesaService";
import ConfigurarRecibosService from "@/services/despesas/ConfigurarRecibosService";
import DespesaAutomaticaService from "@/services/despesas/DespesaAutomaticaService";
import CriticasDespesasService from "@/services/despesas/CriticasDespesasService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
//utils
import Message from "@/models/Message";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
//Components
import Adiantamento from "@/components/despesas/acertos/AcertoAdiantamentos";
import Despesas from "@/components/despesas/acertos/Despesas.vue";

export default {
    components: {
        Adiantamento,
        Despesas,
        ContainerLoader,
    },
    data() {
        return {
            tabs: [],
            tabSelecionada: "",
            serviceDespesa: new DespesaService(this.$http, this.$router),
            serviceAcerto: new AcertoService(this.$http, this.$router),
            serviceAdiantamento: new AdiantamentoService(this.$http, this.$router),
            serviceRecibo: new ConfigurarRecibosService(this.$http, this.$router),
            serviceCritica: new CriticasDespesasService(this.$http, this.$router),
            serviceDespesaAutomatica: new DespesaAutomaticaService(this.$http, this.$router),
            empresaService : new EmpresaService(this. $http,this.$router),
            msgs: [],
            isLoadingPrint: false,
            idusuario: Number(this.$route.params.userId),
            idacerto: Number(this.$route.query.acertoId),
            isShowModalFinish: false,
            isShowModalPrint: false,
            valorTotalDespesas: 0,
            valorTotalDespesasDebita_acerto: 0,
            empresasInner : [],
            valorTotalAdiantamentos: 0,
            motivosDespesas: [],
            despesasSelecionadas: [],
            adiantamentos: [],
            adiantamentosSelecionados: [],
            empresas: [],
            modelosRecibos: [],
            confReciboJasper: {},
            totalAcerto: 0,
            isGeneratingExpenses: false,
            acerto: {
                //OBS GERAL CAPTURADO DO MODAL
                //EMPRESA CAPTURADO DO MODAL
                obsgeral: "",
                situacao: 1,
                idacerto: 0,
                empresa: {
                    idempresa: 0,
                },
                usuario: {
                    idusuario: 0,
                },
                adiantamentos: [],
                despesas: [],
            },
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess("despesas", "acertos", "des-acertos");
        if (!this.permissao.read){
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'acertos' }
            });
        } else {
            //verifica se precisa exibir mensgem da key da api do gmaps
            if(this.permissao.create && this.$route.params.situacaoId === 2){
                this.hasGmapsKeyAndUserKmAuto(this.$route.params.userId)
            }
            // console.log(this.$route.params,'parans');
            // console.log(this.$route.query,'query');
            // console.log(this.idacerto,'acerto');
            if(this.$route.params.situacaoId){
                this.carregarAdiantamentos();
                this.carregarDespesas();
                this.carregarEmpresas();
                this.acerto.idacerto = this.idacerto? this.idacerto : 0;
            }
        }
    },
    computed: {
        nomesEmpresas(){
            return this.empresasInner.map(e => e.nome).join(', ');
        }
    },
    methods: {
        calcularTotalAcerto(){
            const totalDespesas = this.convertInteger(this.valorTotalDespesas);
            const totalAdiantamento = this.convertInteger(this.valorTotalAdiantamentos);

            return totalDespesas - totalAdiantamento
        },
        convertInteger(valor){
            return !valor || valor == " " ? 0 : Number(valor);
        },
        recebeAdiantamentosSelecionados(payload) {
            this.adiantamentosSelecionados = payload;
            this.somarValorTotalAdiantamentos();
            this.somarTotalAcerto();
        },
        recebeDespesasSelecionadas(payload) {
            this.despesasSelecionadas = payload;
            this.somarValorTotalDespesas();
            this.somarTotalAcerto();
        },
        showThisTab(tab, table) {
            return String(tab).toLowerCase() == String(table).toLowerCase()
                ? true : false;
        },
        selecionaEmpresa(){
            if(this.empresasInner == 0) {
                this.motivosDespesas.forEach((motivo) => {
                        motivo.despesas.forEach((despesa) => {
                            this.despesasSelecionadas.push(despesa);
                        });
                });
            } else {
                this.despesasSelecionadas = [];
                this.motivosDespesas.forEach((motivo) => {
                        if (motivo.despesas.length) {
                            motivo.despesas.forEach((despesa) => {
                                this.empresasInner.forEach((empresa) => {
                                    if(despesa.idempresa == empresa.idempresa){
                                        this.despesasSelecionadas.push(despesa);
                                    }
                                })
                            });
                        
                        }
                });
            }
            this.somarValorTotalDespesas();
            this.somarTotalAcerto();
        },
        updateTabs(tab) {
            this.tabSelecionada = tab;
        },
        buildTabs(context) {
            //context é ADIANTAMENTOS ou DESPESASA
            //Se existir adiantamento criará a aba
            if (context == "adiantamentos" && this.adiantamentos.length) {
                this.tabs.unshift("adiantamentos");
            }
            if (context == "despesas") {
                //Crias as tabs que o colaborador possui despesas
                this.motivosDespesas.forEach((motivo) => {
                    if (motivo.despesas.length) {
                        if(this.tabs.indexOf(motivo.descricao) === -1){
                            this.tabs.push(motivo.descricao);
                        }
                    }
                });
            }
            this.tabSelecionada = this.tabs[0];
        },
        addIsCheckedProp(obj) {
            obj.forEach((o) => {
                o.isChecked = false;
            });
        },
        carregarAdiantamentos() {
            this.isLoading = true;
            this.serviceAdiantamento
                .findAllAdiantamentoByIdusuario(this.idusuario, this.idacerto)
                .then((r) => {
                    this.adiantamentos = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar os acertos: " + e);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.addIsCheckedProp(this.adiantamentos);
                    this.buildTabs("adiantamentos");
                });
        },
        carregarDespesas() {
            this.isLoading = true;
            this.serviceDespesa
                .findAllDespesasByIdusuario(this.idusuario, this.idacerto)
                .then((r) => {
                    this.motivosDespesas = r.content;
                    this.motivosDespesas.forEach((motivo) => {
                        if (motivo.despesas.length) {
                            this.despesasSelecionadas.push(...motivo.despesas);
                        }
                    });
                })
                .catch((e) => {
                    console.error("Erro ao carregar os acertos: " + e);
                })
                .finally((r) => {
                    this.isLoading = false;
                    this.somarValorTotalDespesas();
                    this.addIsCheckedProp(this.motivosDespesas);
                    //lembrar de passar o context para o build tabs
                    this.buildTabs("despesas");
                });
        },
        carregarEmpresas() {
            this.empresasLoading = true;
            this.empresaService.findList('')
                .then(r => {
                    if (r.status != 200) {
                        console.error(`[TURNO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[TURNO] Mensagem: ${r.message}`);
                    } else {
                        this.empresas = r.content;
                    }
                })
                .catch(e => {
                    console.error('[TURNO] Erro ao carregar empresas.', e);
                })
                .finally(_ => {
                    this.empresasLoading = false;
                });
        },
        somarValorTotalAdiantamentos() {
            this.valorTotalAdiantamentos = 0;
            //Feito isso para fazer a soma apenas dos selecionados quando for acerto aberto
            //E quando for acerto fechado ele fará a soma de todos os adiantamento do acerto
            if (!this.idacerto) {
                this.adiantamentosSelecionados.forEach((adiantamento) => {
                    this.valorTotalAdiantamentos += adiantamento.valor;
                });
            } else {
                this.adiantamentos.forEach((adiantamento) => {
                    this.valorTotalAdiantamentos += adiantamento.valor;
                });
                this.somarTotalAcerto();
            }
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        somarValorTotalDespesas() {
            this.valorTotalDespesas = 0;
            this.valorTotalDespesasDebita_acerto = 0;
            if (!this.idacerto) {
                this.despesasSelecionadas.forEach((despesa) => {
                    this.valorTotalDespesas += despesa.valor;

                    if(this.isNull(despesa.desFormapagto) || !despesa.desFormapagto.debita_acerto) {
                        this.valorTotalDespesasDebita_acerto += despesa.valor;
                    }
                });
            } else {
                this.motivosDespesas.forEach((motivo) => {
                    motivo.despesas.forEach((despesa) => {
                        this.valorTotalDespesas += despesa.valor;

                        if(this.isNull(despesa.desFormapagto) || !despesa.desFormapagto.debita_acerto) {
                            this.valorTotalDespesasDebita_acerto += despesa.valor;
                        }
                    });
                });
                this.somarTotalAcerto();
            }
        },
        somarTotalAcerto() {
            this.totalAcerto = this.valorTotalDespesasDebita_acerto - this.valorTotalAdiantamentos;
        },

        // funções para finalizar acerto

        onClickFinish() {
            //verifica se possui algum acerto ou adiantamento verificado
            this.montaObjetoAcerto(
                this.adiantamentosSelecionados,
                this.despesasSelecionadas
            );
            if (!this.adiantamentosSelecionados.length && !this.despesasSelecionadas.length) {
                return this.showMessage("error", "msg-erro-nada-selecionado-no-acerto");
            } else {
                this.finalizarAcerto();
            }
        },
        montaObjetoAcerto(adiantamentos, despesas) {
            //Acesso array na posição zero pois sempre será obrigatório ter selecionado algum.
            if (adiantamentos.length) {
                if (adiantamentos[0].usuario) {
                    this.acerto.usuario = adiantamentos[0].usuario;
                }
                this.acerto.adiantamentos = adiantamentos;
            }
            if (despesas.length) {
                if (despesas[0].usuario) {
                    this.acerto.usuario = despesas[0].usuario;
                    this.acerto.despesas = despesas;
                }
            }
        },
        finalizarAcerto() {
            this.isGeneratingExpenses = true;
            this.serviceAcerto
                .finalizar(this.acerto)
                .then((r) => {
                    this.showMessage("success", "msg-sucesso-finalizar-acerto");
                    if(r.content.qntAcertosGerados > 1){
                        this.promptAlertRedirecionamento(r.content.qntAcertosGerados);
                    } else {
                        this.acerto = r.content;
                        this.isGeneratingExpenses = false;
                        this.carregarAcerto();
                        this.$forceUpdate();
                    }
                    
                })
                .catch((e) => {
                    console.error("Erro ao carregar os acertos: " + e);
                    this.showMessage("error", "msg-erro-finalizar-acerto");
                });
        },
        carregarAcerto() {
            this.idusuario = this.acerto.usuario.idusuario;
            this.idacerto = this.acerto.idacerto;
            this.$router.push({
                name: "des-lista-acertos",
                params: { userId: this.acerto.usuario.idusuario },
                query: { acertoId: this.acerto.idacerto }
            });
            this.tabs = [];
            this.motivosDespesas = [];
            this.adiantamentos = [];
            this.valorTotalDespesas = 0;
            this.valorTotalDespesasDebita_acerto = 0;
            this.valorTotalAdiantamentos = 0;
            this.despesasSelecionadas = [];
            this.adiantamentosSelecionados = [];
            this.carregarAdiantamentos();
            this.carregarDespesas();

            if (!this.isShowModalPrint) 
                this.onClickPrint();
        },
        exportarAcerto() {
            this.isLoadingPrint = true;
            if (this.idacerto) {
                this.serviceAcerto
                    .exportarAcerto(this.confReciboJasper.idconfjasper, this.acerto)
                    .then((r) => {
                        let filename = "acerto-" + this.idacerto + ".pdf";
                        let blob = new Blob([r], { type: "application/pdf" });
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute("download", filename);
                        link.click();
                        setTimeout(function () {
                            window.URL.revokeObjectURL(blob);
                        }, 100);
                    })
                    .catch((e) => {
                        console.error("Erro ao gerar pdf: ", { error: e });
                    })
                    .finally((r) => {
                        this.onClickPrint();
                        this.isLoadingPrint = false;
                    });
            } else {
                this.isLoadingPrint = false;
                this.onClickFinish();
            }
        },
        onClickPrint() {
            //busca dodos dos modelos cadastrados de recibos para exibir no pdf que será gerado
            this.buscarModelosRecibo();
            if (
                !this.adiantamentosSelecionados.length &&
                !this.despesasSelecionadas.length &&
                !this.idacerto
            ) {
                return this.showMessage("error", "msg-erro-nada-selecionado-no-acerto");
            } else {
                this.isShowModalPrint = !this.isShowModalPrint;
            }
        },
        downloadArchive(exp) {
            let n = exp.url.lastIndexOf("/");
            let fileName = exp.url.substring(n + 1);
            this.service.exportarAcerto(exp.url).then((r) => {
                let blob = new Blob([r], { type: "application/pdf" });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = fileName;
                link.click();
                setTimeout(function () {
                    window.URL.revokeObjectURL(blob);
                }, 100);
            });
        },
        buscarModelosRecibo() {
            this.serviceRecibo
                .findAllNoPagination('despesa_acerto')
                .then((r) => {
                    this.modelosRecibos = r.content;
                })
                .catch((e) => {
                    console.error("Erro ao carregar os recibox: " + e);
                })
                .finally((r) => {
                    this.modelosRecibos.unshift({
                        idconfjasper: 0,
                        titulo: this.$t("nao-usar-modelo-recibo"),
                    });
                    //atribui como default o objeto acima que sempre ficara na posição 0 pois uso UNSHIFT para add na lista
                    this.confReciboJasper = this.modelosRecibos[0];
                });
        },
        hasGmapsKeyAndUserKmAuto(idusuario){
            // console.log('hasGmapsKeyAndUserKmAuto');
            let hasKey = false;
            this.serviceDespesaAutomatica.hasGmapsKeyAndUserKmAuto(idusuario)
                .then(r => {
                    hasKey = r.content
                })
                .finally(() => {
                    if(!hasKey){
                        this.pomptAlert('empresa-nao-possui-key-gmaps');
                        this.existeCriticaPendente();
                    }else{
                        //verifica se existe checks pendentes para gerar despesasa
                        this.existeCheckPendente();
                    }
                })
            return hasKey;
        },
        existeCheckPendente(){
            // console.log('existeCheckPendente');
            this.serviceDespesaAutomatica.existeCheckPendente({idusuario: this.$route.params.userId})
            .then(r => {
                if(r.content){
                    this.pomptConfirm('usuario-possui-despesas-automaticas-para-serem-geradas')
                }else{
                    this.existeCriticaPendente();
                }
            })
            .catch((e) => {
                console.error("Erro ao verificar check pendente: ", {e});
            })
        },
        pomptConfirm(message){
            this.$root.confirm({
                message: this.$t(message),
                onConfirm:_ => this.geraDespesaAutomatica(),
                onCancel:_ => this.removeConfirm(),
            });
        },
        geraDespesaAutomatica(){
            // console.log('geraDespesaAutomatica');
            this.isGeneratingExpenses = true;
            this.serviceDespesaAutomatica.geraDespesaAutomatica(this.$route.params.userId)
                .then(r => {
                })
                .catch((e) => {
                    this.pomptAlert(e.body.message?e.body.message:'error-ao-atualizar-config')
                    console.error("Erro ao gerar despesas: ", {e});
                })
                .finally(()=> {
                    console.log("Criação das despesas automaticas finalizadas.");
                    this.isGeneratingExpenses = false;
                    this.motivosDespesas = [];
                    this.despesasSelecionadas = [];
                    this.carregarDespesas();
                    this.existeCriticaPendente();
                })
        },
        existeCriticaPendente(){
            // console.log('existeCriticaPendente');
            this.serviceCritica.verificaSeExisteCritica(this.$route.params.userId)
                .then(r => {
                    if(r.content){
                        this.pomptAlert('msg-gerado-criticas');
                    }
                })
                .catch((e) => {
                    console.error("Erro ao verificar check pendente: ", {e});
                })
        },
        pomptAlert(message){
            this.$root.alert({
                message: this.$t(message),
            });
        },
        promptAlertRedirecionamento(value){
            this.$root.alert({
                message: this.$t('multiplos-acertos', { n: value }),
                onConfirm: () => {
                    this.$router.push({ 
                        name: "des-acertos", 
                        params: { id: 1, label : 'fechados'} 
                    });
                }
            });
        },
        removeConfirm(){
            console.log("Despesas pendentes não foram geradas");
        },
    },
    filters: {
        // Filter to truncate string, accepts a length parameter
        truncate(value, length) {
            return value.length > length ? value.substr(0, length) + "..." : value;
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px 20px 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .nav.nav-tabs {
            margin-bottom: 0;
        }
        .nav.nav-tabs li > ::after {
            bottom: -6px;
        }

        .acerto-footer{
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background: $bg-color;
            .adiantamento-footer{
                margin-left: 15%;
            }
            .columns:last-child {
                margin-bottom: 0.75rem !important;
            }
            @media only screen and (max-width: 768px) {
                .adiantamento-footer{
                    margin-left: 0;
                }
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: "";
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }

        @media only screen and (max-width: 760px) {
            .nav.nav-tabs {
                display: none;
            }
        }

        @media only screen and (min-width: 761px) {
            .mobile-tab-list {
                display: none;
            }
        }
    }
    .fa-exclamation-circle {
        color: $primary-color;
        font-size: 3rem;
    }

    .without-padding-bottom {
        padding-bottom: 0px;
    }

    .form-buttons {
        position: relative !important;
        top: 20px;
        margin-bottom: 1rem;
        right: 0;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-pack: end;
        -ms-flex-pack: end;
        justify-content: flex-end;
    }

    h1.title {
        margin-right: 0;
    }

    .modal-card-body {
        border-radius: 0.5rem;
        background: white;
    }

    .select-recibo {
        z-index: 1100;
    }

    //permitir que o select do modal "imprimir" sobreponha o modal
    div.animation-content.modal-content {
        overflow: visible !important;
        background: #000;
    }

    .modal .modal-card-body {
        overflow: visible !important;
    }

    @media only screen and (max-width: 760px) {
        .media-right {
            width: 15rem;
        }
        .form-buttons {
            text-align: center;
            left: 50%;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
            position: relative;
        }
    }

    @media only screen and (max-height: 850px) {
        .media-right {
            width: 15rem;
        }
    }
}
</style>